import { BaseModel } from '../../../../../../core/_base/crud';
    export class KhoDeNghiXuatKho extends BaseModel {
        IdDn : number
        Sophieu : string
        IdPb : number
        BoPhanYeuCau : string
        Ngayxuat : string
        Nguoitao : number
        TenNguoitao : string
        Ngaytao : string
        Nguoisua : number
        Ngaysua : string
        Tinhtrang : string
        DescTinhTrang : string
        Ghichu : string
        Nguoiduyet : number
        TenNguoiduyet : string
        Ngayduyet : string
        Lydokhongduyet : string
        ChiTiet: KhoDeNghiXuatKhoChiTiet[]
        Enable_DaNhanTatCa : boolean
        LoaiPhieu: number
        TenLoaiPhieu: string
        ChoDuyet : number
        ChoDong : number
        clear() {
            this.IdDn = 0;
            this.Sophieu = '';
            this.IdPb = 0;
            this.BoPhanYeuCau = '';
            this.Ngayxuat = '';
            this.Nguoitao = 0;
            this.TenNguoitao = '';
            this.Ngaytao = '';
            this.Nguoisua = 0;
            this.Ngaysua = '';
            this.Tinhtrang = '';
            this.DescTinhTrang = '';
            this.Ghichu = '';
            this.Nguoiduyet = 0;
            this.TenNguoiduyet = '';
            this.Ngayduyet = '';
            this.Lydokhongduyet = '';
            this.ChiTiet = [];
            this.Enable_DaNhanTatCa = false;
            this.LoaiPhieu = 0;
            this.TenLoaiPhieu = '';
            this.ChoDong = 0;
            this.ChoDuyet = 0;
        }
        copy(item:KhoDeNghiXuatKho){
            this.IdDn =  item.IdDn;
            this.Sophieu = item.Sophieu;
            this.IdPb = item.IdPb;
            this.BoPhanYeuCau = item.BoPhanYeuCau;
            this.Ngayxuat = item.Ngayxuat;
            this.Nguoitao = item.Nguoitao;
            this.TenNguoitao = item.TenNguoitao;
            this.Ngaytao = item.Ngaytao;
            this.Nguoisua = item.Nguoisua;
            this.Ngaysua = item.Ngaysua;
            this.Tinhtrang = item.Tinhtrang;
            this.DescTinhTrang = item.DescTinhTrang;
            this.Ghichu = item.Ghichu;
            this.Nguoiduyet = item.Nguoiduyet;
            this.TenNguoiduyet = item.TenNguoiduyet;
            this.Ngayduyet = item.Ngayduyet;
            this.Lydokhongduyet = item.Lydokhongduyet;
            this.ChiTiet = item.ChiTiet;
            this.Enable_DaNhanTatCa = item.Enable_DaNhanTatCa;
            this.LoaiPhieu = item.LoaiPhieu;
            this.TenLoaiPhieu = item.TenLoaiPhieu;
            this.ChoDong = item.ChoDong;
            this.ChoDuyet = item.ChoDuyet;
        }
    }
    export class KhoDeNghiXuatKhoChiTiet extends BaseModel {
        IdCtdn : number
        IdDn : number
        IdHh : number
        MaHH : string
        QuyCach : string
        TenHH : string
        Soluong : number
        MucDichSuDung : string
        NguonPhatSinh : string
        NgayCan : string
        Dvt : number
        TenDvt : string
        GhiChu : string
        DatHangId : number
        DatHangCtId: number
        DatHangSoPhieu : string
        MaKH: string
        TenKH: string
        isError: boolean
        messageError: string
        DaLapPhieuXuatKho: boolean
        XuLy: DM_DuyetChiTiet
        Enable_XacNhan: boolean
        BPDN: number
        TenBPDN : string
        BPSD: number
        TenBPSD: string
        SoLo: string
        SoMay: string
        SLThucXuat : number

        clear() {
            this.IdCtdn = 0;
            this.IdDn = 0;
            this.IdHh = 0;
            this.MaHH = '';
            this.QuyCach = '';
            this.TenHH = '';
            this.Soluong = 0;
            this.MucDichSuDung = '';
            this.NguonPhatSinh = '';
            this.NgayCan = '';
            this.Dvt = 0;
            this.TenDvt = '';
            this.GhiChu = '';
            this.isError = false;
            this.messageError = '';
            this.DatHangId = 0;
            this.DatHangSoPhieu = '';
            this.MaKH = '',
            this.TenKH = '',
            this.DaLapPhieuXuatKho = false,
            this.XuLy = new DM_DuyetChiTiet(),
            this.Enable_XacNhan = false
            this.BPDN = 0
            this.BPSD = 0
            this.SoLo = ''
            this.SoMay = ''
            this.TenBPDN = ''
            this.TenBPSD = ''
            this.SLThucXuat = 0
            this.DatHangCtId = 0
        }
        copy(item:KhoDeNghiXuatKhoChiTiet){
            this.IdCtdn = item.IdCtdn;
            this.IdDn = item.IdDn;
            this.IdHh = item.IdHh;
            this.MaHH = item.MaHH;
            this.QuyCach = item.QuyCach;
            this.TenHH = item.TenHH;
            this.Soluong = item.Soluong;
            this.MucDichSuDung = item.MucDichSuDung;
            this.NguonPhatSinh = item.NguonPhatSinh;
            this.NgayCan = item.NgayCan;
            this.Dvt = item.Dvt;
            this.TenDvt = item.TenDvt;
            this.GhiChu = item.GhiChu;
            this.isError = item.isError;
            this.messageError = item.messageError;
            this.DatHangId = item.DatHangId;
            this.DatHangSoPhieu = item.DatHangSoPhieu;
            this.MaKH = item.MaHH,
            this.TenKH = item.TenKH,
            this.DaLapPhieuXuatKho = item.DaLapPhieuXuatKho,
            this.XuLy = item.XuLy,
            this.Enable_XacNhan = item.Enable_XacNhan
            this.BPDN = item.BPDN
            this.BPSD = item.BPSD
            this.SoLo = item.SoLo
            this.SoMay = item.SoMay
            this.TenBPDN = item.TenBPDN
            this.TenBPSD = item.TenBPSD
            this.SLThucXuat = 0
            this.DatHangCtId = 0
        }
    }

    export class DM_DuyetChiTiet extends BaseModel {
        Id : number
        PhieuDeNghi : number
        PhieuDeNghiCT : number
        ListXacNhanNhanHang  = []
        NguoiDuyet : number
        TenNguoiDuyet : string
        NgayDuyet : string
        LoaiThaoTac : string
        LyDo : string
        NgayDuyetDate: Date
        TenLoaiThaoTac: string
        CoKetQuaDuyet : boolean
        clear(){
            this.Id = 0
            this.PhieuDeNghi = 0
            this.PhieuDeNghiCT = 0
            this.ListXacNhanNhanHang  = []
            this.NguoiDuyet = 0
            this.TenNguoiDuyet = ''
            this.NgayDuyet = ''
            this.LoaiThaoTac = ''
            this.LyDo =''
            this.NgayDuyetDate = new Date()
            this.TenLoaiThaoTac = ''
            this.CoKetQuaDuyet = false
        }
    }


    export class ChiTietSoLuongTonModel extends BaseModel {
        Id : number
        MaKho : string
        TenKho : string
        SLDuocXuat : number
        SLKhongDuocXuat : number
        clear(){
            this.Id = 0;
            this.MaKho = ''
            this.TenKho = ''
            this.SLDuocXuat = 0
            this.SLKhongDuocXuat = 0
        }
        copy(item: ChiTietSoLuongTonModel){
            this.Id = item.Id
            this.MaKho =  item.MaKho
            this.TenKho = item.TenKho
            this.SLDuocXuat = item.SLDuocXuat
            this.SLKhongDuocXuat = item.SLKhongDuocXuat
        }
    }




